import React, {PureComponent} from "react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import "./SocialNetworks.scss";

class CopyTo extends PureComponent {
    state = {
        showTooltip: false
    }
    toggleTooltip = () => {
        this.setState(prevState => {
            return {
                showTooltip: !prevState.showTooltip
            }
        })
    }
    handleReset = () => {
        if (this.state.showTooltip) return;

        setTimeout(this.toggleTooltip, 3000)
    }

    render() {
        const {url} = this.props;
        const {showTooltip} = this.state;
        return <CopyToClipboard text={`https://${window.location.host}${url}`} onCopy={() => {
            this.toggleTooltip();
            this.handleReset();
        }}>
            <a href={"#"} onClick={(e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
            } className={"share-link copy-link"}>
            <svg width="20" height="20" viewBox="0 0 24 24">
                <path fill="#fff"
                      d="M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z"/>
            </svg>
            <span id="tooltip-text"
                  className={"tooltip-text " + (showTooltip ? "" : "tvp-hide")}>Copied to clipboard.</span>
        </a></CopyToClipboard>
    }
}

const SocialNetworks = ({url, asset}) => {
    return (
        <div className={"share"}>
            <div className="social-media-share">
                <a
                    id="facebook-share"
                    target="_blank"
                    className="share-link fb"
                    href={`https://www.facebook.com/sharer/sharer.php?u=https://${window.location.host}${url}`}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="25"
                        viewBox="0 0 14 25"
                    >
                        <path
                            fill="#fff"
                            fillRule="evenodd"
                            d="M8.57 25V13.596h3.894l.583-4.444H8.57V6.315c0-1.287.363-2.164 2.24-2.164l2.393-.001V.175C12.79.121 11.37 0 9.717 0 6.266 0 3.903 2.071 3.903 5.875v3.277H0v4.444h3.903V25h4.668z"
                        ></path>
                    </svg>
                </a>
                <a
                    id="twitter-share"
                    target="_blank"
                    className="share-link tw"
                    href={`https://x.com/intent/tweet?url=https://${window.location.host}${url}`}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 1668.56 1221.19"
                        xmlSpace="preserve"
                    >
                        <g>
                            <g
                                transform="translate(52.390088,-25.058597)"
                            >
                                <path
                                    style={{
                                        fill: '#FFFFFF'
                                    }}
                                    d="M485.39,356.79l230.07,307.62L483.94,914.52h52.11l202.7-218.98l163.77,218.98h177.32 L836.82,589.6l215.5-232.81h-52.11L813.54,558.46L662.71,356.79H485.39z M562.02,395.17h81.46l359.72,480.97h-81.46L562.02,395.17 z"
                                />
                            </g>
                        </g>
                    </svg>
                </a>
                <a
                    className={"share-link pt"}
                    target="_blank"
                    href={`http://pinterest.com/pin/create/button/?url=https://${
                        window.location.host
                    }${url}&media=${
                        asset.asset.thumbnailUrl
                    }&description=${encodeURI(asset.description)}`}
                >
                    <svg
                        width="24px"
                        height="24px"
                        fill={"#000"}
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="#fff"
                            d="M9.04,21.54C10,21.83 10.97,22 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12C2,16.25 4.67,19.9 8.44,21.34C8.35,20.56 8.26,19.27 8.44,18.38L9.59,13.44C9.59,13.44 9.3,12.86 9.3,11.94C9.3,10.56 10.16,9.53 11.14,9.53C12,9.53 12.4,10.16 12.4,10.97C12.4,11.83 11.83,13.06 11.54,14.24C11.37,15.22 12.06,16.08 13.06,16.08C14.84,16.08 16.22,14.18 16.22,11.5C16.22,9.1 14.5,7.46 12.03,7.46C9.21,7.46 7.55,9.56 7.55,11.77C7.55,12.63 7.83,13.5 8.29,14.07C8.38,14.13 8.38,14.21 8.35,14.36L8.06,15.45C8.06,15.62 7.95,15.68 7.78,15.56C6.5,15 5.76,13.18 5.76,11.71C5.76,8.55 8,5.68 12.32,5.68C15.76,5.68 18.44,8.15 18.44,11.43C18.44,14.87 16.31,17.63 13.26,17.63C12.29,17.63 11.34,17.11 11,16.5L10.33,18.87C10.1,19.73 9.47,20.88 9.04,21.57V21.54Z"
                        />
                    </svg>
                </a>
                {/*<a className={"share-link linkedin"}
               target={"_blank"}
               href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${window.location.host}${url}&title=${encodeURI(asset.titleTextEncoded)}`}>
                <svg width="24px" height="24px" viewBox="0 0 24 24">
                    <path fill="#ffffff"
                          d="M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z"/>
                </svg>
            </a>*/}
                <CopyTo url={url} />
            </div>
        </div>
    );
}

export default SocialNetworks;